<template functional>
  <span
    :class="[
      data.staticClass,
      data.class,
      $style.label,
      $kindStyle[props.kindClass],
      $sizeStyle[props.sizeClass],
    ]"
  >
    <slot />
  </span>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'AtomLabel',
  props: {
    kindClass: {
      type: String,
      required: true,
    },
    sizeClass: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss" module>
.label {
  display: inline-block;
  flex-shrink: 0;
  border-radius: $BORDER_RADIUS_LABEL;
  text-align: center;
  mix-blend-mode: multiply;
}
</style>

<!-- styles by props -->
<style lang="scss" module="$kindStyle">
@use '@/components/atoms/AtomLabelKindStyle.scss' as *;
</style>

<style lang="scss" module="$sizeStyle">
.small {
  @include font(10, medium, label);
  padding: 5px 10px;
}

.large {
  @include font(12, medium, label);
  padding: 6px 10px;
}
</style>
